import { render, staticRenderFns } from "./CardAdvanceProfile.vue?vue&type=template&id=087e4e8e&"
import script from "./CardAdvanceProfile.vue?vue&type=script&lang=js&"
export * from "./CardAdvanceProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports